// # Route constants
import { AuthLogin } from './pages/login/types';
import { ItemToolTip } from './utils/types';

export const LOGIN = '/login';
export const CALLBACK = '/callback';
export const UNAUTHORIZED = '/unauthorized';
export const MYMETRICS = '/mymetrics';
export const SCORECARD = '/scorecard';
export const EDSDASHBOARD = '/edsDashboard';
export const ADMINIMPERSONATE = '/impersonate';
export const SCORECARDDASHBOARD = '/scorecardDashboard';
export const COMPENSATION = '/compensation';
export const MANAGERDASHBOARD = '/managerDashboard';
export const SCORECARDRULES = '/scorecardRulesAndActivity';
//export const CORRECTIVEACTIONS = '/correctiveActions';
export const CATEMPLATES = '/correctiveActionTemplates';
export const CORRECTIVEACTIONASSIGNMENT = '/correctiveActionAssignment';
export const MYCORRECTIVEACTIONS = '/mycorrectiveActions';
export const HCAPPROVERS = '/hcApprovers';
export const RECORDS = '/records';
export const COACHING = '/coaching';
export const ADMIN = '/admin';
export const PENDINGAPPROVALS = '/pendingApprovals';
export const CAMENU = '/caMenu';
export const CALLINSIGHT = '/callInsight';
// export const HOMEPAGE = '/homePage';
export const STACKRANK = '/stackRank';
export const GAMEPLAN = '/gamePlan';
export const LANDINGPAGE = '/LandingPage';
export const METRICSADMIN = '/metricsAdmin';
export const ACTIONPLAN = '/coachingActionPlan';

// V2 Coaching Observation Form
export const GET_TRIAD_QUESTIONS_BY_VERSION = 'triad/triad_question_by_version';

export const AUTHDATA: AuthLogin = {
    empid: 750,
    user: 'Tania',
    role: 'agent',
    userManagerLevel: 'Non Manager',
    isAdmin: false,
    token: '',
    refreshToken: null,
    expiresIn: null,
    impEmpid: null,
    impUser: null,
    impRole: null,
    impUserManagerLevel: null,
    impIsAdmin: null,
    isUserImpersonate: null,
    isEds: null,
    impIsEds: null,
    isComp: null,
    impIsComp: null,
    userFullName: null,
    isDelegate: null,
    isHC: null,
    impIsHC: null,
};

// # Auth constans
export const ROLES = {
    Agents: ['Non-Manager'],
    Supervisor: ['Supervisor 1', 'Supervisor 2'],
    SupervisorORAgents: ['Non-Manager', 'Supervisor 1', 'Supervisor 2'],
    SupervisorOrOnlyManager: ['Supervisor 1', 'Supervisor 2', 'Manager 1', 'Manager 2'],
    OnlyManager: ['Manager 1', 'Manager 2'],
    Manager: [
        'Manager 1',
        'Manager 2',
        'Director 1',
        'Director 2',
        'Vice-President 1',
        'Vice-President 2',
        'Senior Vice President',
        'Senior Vice President 2',
        'Executive Vice President',
        'Operating Committee Mem',
        'Chief Officer',
    ],
    DirectorOrAbove: [
        'Director 1',
        'Director 2',
        'Vice-President 1',
        'Vice-President 2',
        'Senior Vice President',
        'Senior Vice President 2',
        'Executive Vice President',
        'Operating Committee Mem',
        'Chief Officer',
    ],
    SupervisorORManager: [
        'Supervisor 1',
        'Supervisor 2',
        'Manager 1',
        'Manager 2',
        'Director 1',
        'Director 2',
        'Vice-President 1',
        'Vice-President 2',
        'Senior Vice President',
        'Senior Vice President 2',
        'Executive Vice President',
        'Operating Committee Mem',
        'Chief Officer',
    ],
    SupervisorORAgentsORManager: [
        'Non-Manager',
        'Supervisor 1',
        'Supervisor 2',
        'Manager 1',
        'Manager 2',
        'Director 1',
        'Director 2',
        'Vice-President 1',
        'Vice-President 2',
        'Senior Vice President',
        'Senior Vice President 2',
        'Executive Vice President',
        'Operating Committee Mem',
        'Chief Officer',
    ],
    Admin: ['Non-Manager'],
    Supervisor2AndAbove: [
        'Supervisor 2',
        'Manager 1',
        'Manager 2',
        'Director 1',
        'Director 2',
        'Vice-President 1',
        'Vice-President 2',
        'Senior Vice President',
        'Senior Vice President 2',
        'Executive Vice President',
        'Operating Committee Mem',
        'Chief Officer',
    ],
    Supervisor2AndManagers: ['Supervisor 2', 'Manager 1', 'Manager 2'],
};

export const ALERT_AGENT_APPROVAL =
    'It is currently the Associate Approval Window for one or more of your assigned scorecards.';
export const ALERT_TL_APPROVAL =
    'It is currently the Team Lead Approval Window for one or more of your associated scorecards.';
export const ALERT_MANAGER_APPROVAL =
    'It is currently the Manager Approval Window for one or more of your associated scorecards.';

export const TOOLTIPSTALLED = 'Stalled';
export const TOOLTIPTEMPLATEUSED = 'Template in use, cannot modify';
export const TOOLTIPSTRENGTH = 'Document and communicate associate strengths';
export const TOOLTIPMETRIC =
    'Review each associates metric attainment, Identify document actions items using ToDo’s';
export const TOOLTIPDISCUSSION =
    'The target completion count and percentage include only those Discussions where the category “CAP” is chosen';
export const TOOLTIPFILTER =
    ' Select a Scorecard directly or apply the filters above to narrow down the Scorecard Options';
export const TOOLTIPDISPUTE = ' Metrics disputes for Associates. Scorecard disputes for Team Lead.';
export const TOOLTIPLOOKUP =
    'Search for an associate. Empower will populate the Scorecard Filter using the data from the Scorecard they are assigned to using the Scorecard Date selection.';
export const TOOLTIPTOLERENCE = 'Select to filter where Variance >= Tolerance Setting.';
export const TOOLTIPCURRENT = 'Average for selected month.';
export const TOOLTIPAVERAGE = 'Up to 3 month average.';
export const TOOLTIPVARIANCE = 'Difference between Current Average and 3 Month Average.';
export const AGENTROLE = 'agent';
export const SUPERVISORROLE = 'supervisor';
export const MANAGERROLE = 'manager';

export const ADMIN_SECURITY_GROUP = 'Empower Admin';
export const EDS_SECURITY_GROUP = 'Empower EDS';
export const COMPENSATION_SECURITY_GROUP = 'Empower Compensation';
export const HC_SECURITY_GROUP = 'EmpowerHC';

// # Search Controllers and actions
export const SEARCH_PARENTCLIENTS = 'search/parent_clients';
export const SEARCH_CLIENTS = 'search/clients';
export const SEARCH_PROGRAMS = 'search/programs';
export const SEARCH_PROJECTS = 'search/projects';
export const SEARCH_SCORECARD = 'search/scorecard';
export const SEARCH_COUNTRIES = 'search/countries';
export const SEARCH_SITES = 'search/sites';
export const SEARCH_NAME = 'search/employee_info_by_name';
export const SEARCH_ID = 'search/employee_info_by_id';
export const SEARCH_SCORECARD_BY_ID = 'search/scorecard_id_lookup';
export const SEARCH_FEATURE_TYPES = 'search/feature_types';
export const COUNTIES_BY_EMPLOYEE_NUMBER = 'search/counties_by_employee_number';

export const PARENT_CLIENT_BY_CONFIG = 'search/parent_clients_by_config';
export const CLIENT_BY_CONFIG = 'search/clients_by_config';
export const PROGRAM_BY_CONFIG = 'search/programs_by_config';
export const PROJECT_BY_CONFIG = 'search/projects_by_config';
export const COUNTRY_BY_CONFIG = 'search/countries_by_config';
export const GLLOCATIONS_BY_CONFIG = 'search/gl_locations_by_config';
export const AGENTS_SEARCH = 'search/agents_search';
export const ALL_PARENT_CLIENTS = 'search/all_parent_clients';

// # employee_metric Controllers and actions
export const EMPLOYEE_METRIC_STATUS = 'employee_metric/status';
export const EMPLOYEE_METRIC_PAYOUT_STATUS = 'employee_metric/payout_status';

export const MONTHLY_METRIC_SUMMARY = 'employee_metric/monthly_metric_summary';
export const EMPLOYEE_SCORECARD_DAILY_METRIC_SUMMARY = 'employee_metric/scorecard_agents_daily_metrics';

export const EMPLOYEE_DAILY_METRIC_SUMMARY = 'employee_metric/Daily_metric_summary';
export const EMPLOYEE_DAILY_METRIC_SUMMARY_EXPORT = 'employee_metric/daily_metric_summary_export';
export const EMPLOYEE_TEAMLEAD_AGENTS = 'employee_metric/teamlead_agents';
export const DISPUTE_UPDATE_REVIEW_STATUS = 'dispute/update_review_status';
export const EMPLOYEE_METRIC_ALL_PAYOUTS = 'employee_metric/employee_metric_all_payouts';
export const EMPLOYEE_PAYOUT_DETAILS = 'employee_metric/employee_payout_details';
export const EMPLOYEE_PAYOUT_METRIC_ATTAINMENT = 'employee_metric/payout_metric_attainment';
export const EMPLOYEE_SCORECARDS_BY_ROLE = 'employee_metric/scorecards_by_role';
export const AGENT_APPROVAL_STATUS_SEARCH = 'employee_metric/agent_approval_status_search';
export const EMPLOYEE_MONTHLY_METRIC_HISTORY = 'employee_metric/monthly_metric_history';
export const GET_TEAM_MONTHLY_METRIC_VIEW = 'employee_metric/team_monthly_metric_view';
export const GET_TEAM_DAILY_METRIC_VIEW = 'employee_metric/team_daily_metric_view';
export const GET_METRIC_TARGETS = 'employee_metric/metric_targets';
export const GET_SCORECARD_BONUS_PENALTY_DATA = 'employee_metric/scorecard_monthly_bonus_penalty';
export const GET_METRICS = 'employee_metric/metrics';
export const GET_METRIC_CATEGORIES = 'employee_metric/metric_category';
export const GET_METRIC_FREQUENCIES = 'employee_metric/metric_frequencies';
export const GET_METRIC_TYPES = 'employee_metric/metric_types';
export const CREATE_METRIC = 'employee_metric/create_metric';
export const GET_METRIC_BY_ID = 'employee_metric/metric';
export const UPDATE_METRIC = 'employee_metric/update_metric';
export const PARSE_FORMULA = 'employee_metric/parse_formula';
export const CHECK_METRIC_NAME = 'employee_metric/check_metric_name';
export const GET_MANAGER_APPROVER_SCORECARD = 'employee_metric/manager_approver_scorecards';
export const PAYOUT_DAILY_DISPUTE_METRICS = 'employee_metric/payout_daily_dispute_metrics';
export const EMPLOYEE_MONTHLY_METRIC_ATTAINMENT = 'employee_metric/emp_monthly_metric_attainment';
export const EMPLOYEE_PAYOUT_LEVEL_METRIC_RATES = 'employee_metric/emp_payout_level_metric_rates';

// # Scorecard Controllers and actions
// export const SCORECARDS_BY_ROLE = 'employee_metric/scorecards_by_role';
// export const TEAMLEAD_MONTHLY_METRIC_SUMMARY = 'employee_metric/scorecard_monthly_metric_summary';
export const EMPLOYEE_TEAMLEAD_SCORECARD_AGENTS = 'employee_metric/teamlead_scorecard_agents';
export const STACK_RANK_SEARCH = 'employee_metric/stack_rank_search';
export const TEAMLEAD_PIE_SCORECARDS = 'employee_metric/scorecard_agents_metric_summary';
export const TEAMLEAD_PIE_SCORECARDS_TIER = 'employee_metric/scorecard_agents_tier_attainment_summary';
export const SCORECARDS_DISPUTES = 'dispute/scorecard_disputes';

export const TEAMLEAD_PAYOUT_DATA = 'employee_metric/teamlead_payouts';
export const TEAMLEAD_PAYOUT_MONTHS = 'employee_metric/teamlead_payout_months';
export const TEAMLEAD_PAYOUT_DETAILS = 'employee_metric/teamlead_payout_details';

// # Eds Controllers and actions
export const TEAMLEAD_MONTHLY_METRIC_SUMMARY_EDS = 'employee_metric/scorecard_monthly_metric_summary_eds';
export const TEAMLEAD_PIE_SCORECARDS_EDS = 'employee_metric/scorecard_agents_metric_summary_eds';
export const EMPLOYEE_TEAMLEAD_SCORECARD_AGENTS_EDS = 'employee_metric/teamlead_scorecard_agents_eds';

// # Build references
export const BUILD_ID = process.env.REACT_APP_APP_BUILD_ID as string;
export const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER as string;

// # define the API remote and settings
export const API_URI = process.env.REACT_APP_API_URI as string;

export const API_URI_IDENTITY = process.env.REACT_APP_API_URI_IDENTITY as string;
export const RESPONSE_TYPE = process.env.REACT_APP_RESPONSE_TYPE as string;
export const SCOPE = process.env.REACT_APP_SCOPE as string;
export const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI as string;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID as string;
export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as string;

export const PRODUCTION_APP_ENVIRONMENT = 'EmpowerProduction';
export const DEV_APP_ENVIRONMENT = 'EmpowerDev';

export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET as string;
export const GRANT_TYPE = process.env.REACT_APP_GRANT_TYPE as string;
export const PING_AUTH_URI = process.env.REACT_APP_PING_AUTH_URI as string;
export const PING_TOKEN_URI = process.env.REACT_APP_PING_TOKEN_URI as string;
export const LOOKER_DASHBOARD_URI = process.env.REACT_APP_LOOKER_DASHBOARD_URI as string;
export const ASKTED_TTEC_DASHBOARD_URI = process.env.REACT_APP_ASKTED_TTEC_DASHBOARD_URI as string;
// # User Controller end point
export const EMPLOYEE_USER_ACTIVITY_LOG = 'user/user_activity_log';
export const IMPERSONATOR_DETAIL = 'user/impersonator_details';
export const FEATURE_REQUEST = 'user/feature_request';
export const ABOUT_ME_PERSONALIZATION = 'user/about_me_personalization';
export const CREATE_UPDATE_ABOUT_ME_PERSONALIZATION = 'user/create_update_about_me';
export const USER_REPORTEES_COUNT = 'user/user_reportees_count';
export const GET_CONFIG_SWITCH_FOR_EMPLOYEE = 'user/get_config_switch_for_employee';
export const GET_ALL_CONFIG_SWITCHES_FOR_EMPLOYEE = 'user/get_all_config_switches_for_employee';
export const GET_MANAGER_RECENT_APPROVER_STATUS = 'user/get_manager_recent_approver_status';
export const GET_PROFILE_PHOTO = 'user/profile_photo';

// # EDS actions
export const SCORECARD_AGENTS = 'employee_metric/scorecard_agents';
export const AGENT_DAILY_METRICS = 'employee_metric/agent_daily_metrics';

// # Problem Report Actions
export const ISSUE_TYPES = 'employee_metric/issue_types';
export const REPORT_PROBLEM = 'employee_metric/report_problem';

// # Disputes
export const DISPUTE_STATUS = 'dispute/dispute_status';
export const RESOLUTION_REASONS = 'dispute/reasons';
export const RESOLVE_DISPUTE = 'dispute/update_resolve_dispute';
export const SCORECARD_AGENT_DISPUTE_DETAILS = 'dispute/scorecard_agents_daily_disputes';
export const APPROVAL_HALT_REASONS = 'dispute/reasons';

// #Dispute Controller end point
export const DISPUTE_REASONS = 'dispute/reasons';
export const DISPUTE_CREATE = 'dispute/create_dispute';
export const DISPUTE_UPDATE = 'dispute/update_dispute';
export const DISPUTE_GET = 'dispute/disputes';
export const DISPUTE_GET_SCORECARD_OVERRIDE = 'dispute/scorecard_assign';
export const DISPUTE_GET_SCORECARDS = 'dispute/scorecards';
export const DISPUTE_GET_SCORECARD_ROLEID = 'dispute/scorecard_roleid';
export const DISPUTE_GET_EMP_MONTHLY_RESULT_REVIEW_STATUS = 'dispute/emp_monthly_result_review_status';
export const SCORECARD_TEAM_MEMBER = 'dispute/scorecard_group_assign_employees';
export const SCORECARD_ASSIGN_OVERRIDE = 'dispute/scorecard_group_assign_overrides';
export const START_DATE_OVERRIDE_EXCEPTIONS = 'dispute/start_date_overrides';
export const SCORECARD_ASSIGN_OVERRIDE_EXCEPTIONS = 'dispute/project_start_assign_overrides';
export const DELETE_START_DATE_OVERRIDE_EXCEPTIONS = 'dispute/delete_scorecard_project_start_override';
export const DELETE_SCORECARD_ASSIGN_OVERRIDE_EXCEPTIONS =
    'dispute/delete_exception_scorecard_assign_override';

export const DISPUTE_SCORECARD_CREATE = 'dispute/create_dispute_scorecard';
export const DELETE_GROUP_ASSIGN_SCORECARD = 'dispute/update_group_assign_status';
export const ASSIGN_SCORECARD_GROUP = '/dispute/create_scorecard_group_assign';
export const START_DATE_OVERRIDE_CREATE = 'dispute/start_date_override';
export const SCORECARD_ASSIGN_CREATE = 'dispute/create_scorecard_assign';
export const DISPUTE_UPDATE_ALL_DISPUTES = 'dispute/update_all_disputes';
export const DISPUTE_RESOLVE = 'dispute/resolve_dispute';
export const DISPUTE_ALL_RESOLVE = 'dispute/resolve_all_disputes';
export const DISPUTE_RECALCULATE_ASSOCIATE = 'dispute/recalculate_associate';

// # Approvals
export const PAYOUT_APPROVALS = 'approval/teamlead_agents_payout_approvals';
export const PAYOUT_APPROVALS_EXPORT = 'approval/employee_payout_details_export';
export const UPDATE_APPROVAL_MANAGER = 'approval/update_approval_status_for_manager';
export const SCORECARD_STATUS = 'approval/scorecard_status';
export const PRIMARY_APPROVAL_WINDOW = 'approval/primary_approval_window';
export const SCORECARD_APPROVE_PCT_SEARCH = 'approval/scorecard_approve_pct_search';
export const SCORECARD_ROLES = 'approval/scorecard_roles';
export const UPDATE_INSERT_SCORECARD_APPROVAL_WINDOW = 'approval/update_insert_scorecard_approval_window';
export const UPDATE_APPROVAL_WINDOW_OVERRIDE = 'approval/update_approval_window_override';
export const UPDATE_DISQUALIFY_APPROVAL = 'approval/update_disqualify_approval';
export const UPDATE_APPROVAL_STATUS = 'approval/update_approval_status';
export const UPDATE_PAYOUT_EXTRACT_STATUS = 'approval/update_payout_extract_status';
export const UPDATE_PAYOUT_APPROVALS = 'approval/update_payout_approvals';
export const UPDATE_CERTIFIED_SCORECARD_APPROVAL_WINDOW =
    'approval/update_certified_scorecard_approval_window';
export const PAYOUT_EXTRACT_HISTORY = 'approval/payout_extract_history';
export const PAYOUT_EXTRACT_DETAILS = 'approval/payout_extract_details';
export const APPROVAL_WINDOW_NOTIFICATION = 'approval/approval_window_notification';

// # Approvals halt and Reinitiate
export const HALT_REINIT_APPROVALS = 'approval/scorecard_halt_reinit_approvals';
export const SCORECARD_HALT_APPROVALS = 'approval/scorecard_halt_approvals';

// #Dispute Controller end point
export const DELEGATE_HISTORY = 'delegate/delegate_history';
export const CREATE_DELEGATE = 'delegate/create_delegate';
export const DEACTIVATE_DELEGATE = 'delegate/deactivate_delegate';
export const DELEGATE_ASSOCIATE_SEARCH = 'delegate/delegate_associate_search';

// # ScorecardRule
export const SCORECARD_APPROVAL_ACTIVITY = 'scorecard_rules_and_activity/scorecard_approval_activity';
export const SCORECARD_PAYOUT_AGING = 'scorecard_rules_and_activity/scorecard_payout_aging';
export const SCORECARD_PAYOUT_AGING_COUNT = 'scorecard_rules_and_activity/scorecard_payout_aging_count';
export const SCORECARD_EMPLOYEE_PAYOUT_COUNT = 'scorecard_rules_and_activity/employee_payout_aging_count';

export const SCORECARD_RULES_STATUS = 'scorecard_rules_and_activity/scorecard_rules_status';
export const PAY_QUALIFIERS = 'scorecard_rules_and_activity/employee_payqualifier_details';
export const SCORECARD_HEADER_INFO = 'scorecard_rules_and_activity/scorecard_header_info';
export const METRIC_HEADER_INFO = 'scorecard_rules_and_activity/metric_header_info';
export const SCORECARD_APPROVAL_ACTIVITY_EMPLOYEE =
    'scorecard_rules_and_activity/scorecard_approval_employee_activity';
export const EMPLOYEE_PAYRULES_TENURE_DETAILS =
    'scorecard_rules_and_activity/employee_payrule_tenure_details';
export const ALL_SCORECARD_DISPUTES = 'scorecard_rules_and_activity/all_scorecard_disputes';
export const SCORECARD_PAYOUT_CRITERIA = 'scorecard_rules_and_activity/scorecard_payout_criteria';
export const EMPLOYEE_DIMENSION_HISTORY = 'scorecard_rules_and_activity/employee_dimension_history';
export const KRONOS_TIME_REASONABLENESS = 'scorecard_rules_and_activity/kronos_time_reasonableness';
export const SCORECARD_WINDOW_COMMENTS = 'scorecard_rules_and_activity/scorecard_window_comments';
export const CREATE_SCORECARD_WINDOW_COMMENTS =
    'scorecard_rules_and_activity/create_scorecard_window_comments';

//#peerController
export const NOTIFY_PEER ='peer/notify';


//# CorretiveActions
export const ALL_COUNTRIES = 'corrective_action/all_countries';
export const CA_TEMPLATE = 'corrective_action/ca_template';
export const CA_SCORECARD_ROLES = 'corrective_action/scorecard_roles';
export const CA_CATEGORIES = 'corrective_action/categories';
export const CREATE_CA_TEMPLATE = 'corrective_action/create_ca_template';
export const CA_SEVERITY_LEVEL = 'corrective_action/ca_severity_level';
export const CA_LANGUAGE = 'corrective_action/ca_emplanguage';
export const CA_TOKENS = 'corrective_action/ca_tokens';
export const CA_CREATE_CONFIGURE = 'corrective_action/create_ca_configurated_items';
export const CA_UPDATED_CONFIGURE = 'corrective_action/update_ca_configurated_items';
export const CA_TEMPLATE_NOTICE = 'corrective_action/ca_template_notice';
export const CA_NOTICE_UPDATE_STATUS = 'corrective_action/update_ca_configurated_items_status';
export const CA_APPROVERROLES = 'corrective_action/approverRoles';
export const CA_APPROVALOPTIONS = 'corrective_action/approvalOptions';
export const CREATE_CA_APPROVAL_QUEUES = 'corrective_action/create_ca_approval_queues';
export const CA_EMPLOYEES = 'corrective_action/employees';
export const CA_SEARCH = 'corrective_action/ca_search';
export const CA_VIEW = 'corrective_action/ca_view';
export const CA_CA_DOCUMENTS = 'corrective_action/ca_documents';
export const CA_SUB_CATEGORIES = 'corrective_action/subcategories';
export const CA_NOTICE_ASSIGNMENT = 'corrective_action/ca_template_notice_search';
export const CA_ASSIGN = 'corrective_action/assign_corrective_action';
export const CA_UPDATE = 'corrective_action/update_corrective_action_status';
export const CA_DELETE = 'corrective_action/delete_corrective_action';
export const CA_HISTORY = 'corrective_action/ca_history';
export const CA_APPROVAL_QUEUES = 'corrective_action/ca_approval_queues';
export const CA_APPROVER_DETAILS = 'corrective_action/ca_approver_details';
export const CA_APPROVAL_STATUS_HISTORY = 'corrective_action/ca_approval_status_history';
export const HC_APPROVER_CONFIGS = 'corrective_action/hc_approver_configs';
export const JOB_CODES = 'corrective_action/job_codes';
export const HC_APPROVER_CONFIG_EMPLOYEE = 'corrective_action/hc_approver_config_employees';
export const CONFIG_HC_APPROVERS = 'corrective_action/config_hc_approvers';
export const CA_RECORDS = 'corrective_action/ca_records';
export const GET_CA_TEMPLAT_LANGUAGE = 'corrective_action/ca_template_language';
export const GLLOCATIONS = 'corrective_action/gl_locations';
export const CA_PARENT_CLIENT = 'corrective_action/parent_client';
export const CA_PROGRAMS = 'corrective_action/programs';
export const DELETE_CA_DOCUMENT = 'corrective_action/delete_ca_document';
export const CA_MISCONDUCT = 'corrective_action/ca_misconduct';

// Notification controller and actions

export const EMPLOYEE_NOTIFICATIONS = 'notification/employee_notification';
export const NOTIFICATION = 'notification/update_notification';
export const DELETE_NOTIFICATION = 'notification/delete_notification';
export const EMPLOYEE_SERVICENOW_APPROVALS = 'notification/employee_servicenowapprovals';

// # Coaching controller and actions
export const GET_CORE_VALUES = 'coaching/core_values';
export const GET_COACHING_CATEGORIES = 'coaching/coaching_categories';
export const GET_COACHING_SUMMARY = 'coaching/coaching_summary';
export const GET_COACHING_MYACTIVITY_SUMMARY = 'coaching/coaching_myactivity_summary';
export const GET_COACHING_EMPLOYEE_SEARCH = 'coaching/coaching_employee_search';
export const GET_COACHING_GRID_SEARCH = 'coaching/coaching_grid_search';
export const CREATE_COACHING_CONVERSATION = 'coaching/coaching_conversation';
export const REPLY_COACHING_CONVERSATION = 'coaching/reply_coaching_conversation';
export const GET_COACHING_CONVERSATION_MODAL = 'coaching/coaching_conversation_modal';
export const GET_COACHING_CONVERSION_VIEW = 'coaching/coaching_conversation_view';
export const GET_COACHING_STRENGTHS = 'coaching/coaching_strengths';
export const CREATE_COACHING_TODO = 'coaching/coaching_todo';
export const GET_LATEST_TODOS = 'coaching/coaching_todo_lists';
export const CREATE_COACHING_SHOUTOUT = 'coaching/create_coaching_shoutout';
export const GET_LATEST_SHOUTOUT = 'coaching/latest_shoutouts';
export const ACKNOWLEDGE_COACHING_CONVERSATION = 'coaching/acknowledge_coaching_conversation';
export const COACHING_CONVERSATION_UPDATE = 'coaching/coaching_conversation_update';
export const DELETE_COACHING = 'coaching/delete_coaching';
export const ALL_PARENT_CLIENTS_WITH_MANAGERS = 'coaching/all_parent_clients_with_managers';
export const GET_PARENT_CLIENT = 'coaching/parent_client';
export const GET_MANAGERS = 'coaching/get_managers';
export const TWO_UP_MANAGERS_PC = 'coaching/two_up_managers_pc';
export const ONE_UP_TEAMLEADS_PC = 'coaching/one_up_teamlead_pc';
export const ASSOCIATES_PC = 'coaching/associate_pc';
export const GET_AGENT_NON_METRIC_DISCUSSIONS = 'coaching/agent_non_metric_discussions';
export const GET_AGENT_METRIC_DISCUSSIONS = 'coaching/agent_metric_discussions';
export const GET_COACHING_CONVERSATION_SEARCH = 'coaching/coaching_conversation_search';
export const GET_COACHING_SKILL = 'coaching/coaching_skill';
export const GET_COACHING_BEHAVIOR = 'coaching/coaching_behavior';
export const GET_COACHING_ACTION = 'coaching/coaching_action';
export const GET_CAP_DATA = 'coaching/cap_data';
export const CREATE_CAP_RECORD = 'coaching/create_cap_record';

//Coaching action plan
export const GET_COACHING_ACTION_PLAN_ANALYSIS_TYPES = 'coaching-action/analysis-types';
export const GET_COACHING_HISTORY = 'coaching-action/history';
export const SAVE_COACHING_ANALYSIS_NOTES = 'coaching-action/session/analysis';
export const UPDATE_SESSION_REVIEW = 'coaching-action/session/review';
export const GET_CAP_SESSION = 'coaching-action/cap_session';
export const GET_FOLLOWUP_PERIOD_RESULT = 'coaching-action/followup_period_result';
export const INSERT_COACHING_SESSION = 'coaching-action/insert_coaching_session';
export const LINK_CORRECTIVE_ACTION_TO_CAP = 'coaching-action/link-corrective-action';
export const GET_SESSION_ANALYSIS_TYPES  = 'coaching-action/session';
export const SAVE_SESSION_ANALYSIS_TYPES = 'coaching-action/session/analysis-types';
export const GET_SURVEY_QUESTIONS   = 'coaching-action/survey/questions';
export const SUBMIT_SURVEY_RESPONSE = 'coaching-action/survey/response';
export const CLOSE_COACHING_ACTION_PLAN = 'coaching-action/close';
export const CALCULATE_NEXT_BEST_ACTION_ASSOCIATE = 'coaching-action/calculate-nba';
export const UPDATE_NBA_ACTIONED = 'coaching-action/update_nba_actioned';

//Admin controller and actions
export const GET_EDS_COMP_ASSIGNMENTS = 'admin/eds_comp_assignments';
export const CREATE_EDS_COMP_ASSIGNMENTS = 'admin/create_eds_comp_assignment';
export const DELETE_EDS_COMP_ASSIGNMENTS = 'admin/delete_eds_comp_assignment';
export const ADMIN_NOTIFICATION_TEMPLATE = 'admin/notification_templates';
export const ADMIN_NOTIFICATION_TEMPLATE_CREATE = 'admin/create_notification_templates';
export const ADMIN_NOTIFICATION_TEMPLATE_UPDATE = 'admin/update_notification_templates';

// Mood meter

export const GET_USER_ACTIVE_COUNT = 'user/user_activity_count';
export const GET_PERSONALIZATION = 'user/about_me_personalization';
export const SUBMIT_MOOD_METER = 'moodmeter/submit_mood_meter';
export const GET_COUNT_USERS_GROUP_MOOD = 'moodmeter/count_users_group_mood';
export const GET_NAME_USERS_GROUP_MOOD = 'moodmeter/name_users_group_mood';

// Triads
export const GET_TRIAD_QUESTIONS = 'triad/triad_question';
export const GET_TRIAD_SCORE = 'triad/triad_score';
export const CREATE_TRIAD = 'triad/create_coaching_triad';
export const CREATE_TRIAD_RESPONSE = 'triad/create_triad_response';
export const UPDATE_TRIAD_RESPONSE = 'triad/update_coaching_triad';
export const GET_TRIAD = 'triad/coaching_triad';
export const GET_TRIAD_INFO = 'triad/coaching_triad_info';
export const TRIAD_RESPONSE = 'triad/triad_response';
export const GET_TRIAD_TL_GRAPHIC_HISTORY = 'triad/triad_tl_graphic_history';
export const GET_TRIAD_CAPABILITY_BUCKET = 'triad/triad_capability_bucket';

export const TRIAD_AUTO_SAVE_INTERVAL = 20 * 1000;

//Coaching Insights
export const GET_COACHING_INSIGHT_SUMMARIES = 'call_insight/call_summaries';
export const CREATE_COACHING_INSIGHT_FEEDBACK = 'call_insight/create_coaching_insight_feedback';
export const GET_COACHING_INSIGHT_FEEDBACK = 'call_insight/coaching_insight_feedback';
export const GET_SHOW_COACHING_INSIGHTS = 'call_insight/show_coaching_insights';
export const GET_COACHING_INSIGHT_HISTORY = 'call_insight/coaching_insight_history';
export const GET_COACHING_INSIGHT_FEEDBACK_DETAILS = 'call_insight/coaching_insight_feedback_details';
export const GET_INSIGHT_CALL_DETAILS = 'call_insight/coaching_insight_call_details';
export const GET_COACHING_INSIGHT_CONFIG = 'call_insight/coaching_insight_config';

export const GET_COACHING_DUE_TODOS = 'coaching/coaching_due_todos';

export const GET_GAME_PLAN = 'game_plan/gameplan';
export const GET_GAMEPLAN_SCORECARD_SUMMARY = 'game_plan/gameplan_scorecard_summary';
export const GET_GAMEPLAN_CA_SUMMARY = 'game_plan/gameplan_ca_summary';
export const GET_GAMEPLAN_STRENGTH_SUMMARY = 'game_plan/gameplan_strength_summary';
export const GET_GAMEPLAN_CONVERSATION_SUMMARY = 'game_plan/gameplan_conversation_summary';

// # Coaching Action Plans actions
export const GET_ACTIVE_ACTION_PLANS = 'coaching-action/active_action_plans';
export const GET_COACHING_ACTION_PLANS = 'coaching-action/action_plans';
export const GET_SUPERVISORS_BY_MANAGER = 'coaching-action/supervisors_by_manager';
export const DELETE_ACTION_PLAN = 'coaching-action/delete_action_plan';

export const MENUITEM_TOOL_TIPS: ItemToolTip[] = [
    {
        title: 'Home',
        targetClass: '.leftNavHomeViewLogo',
    },
    {
        title: 'Performance',
        targetClass: '.leftNavPerformanceBtn',
    },
    {
        title: 'Manager View',
        targetClass: '.leftNavManagerViewBtn',
    },
    {
        title: 'Course Catalog',
        targetClass: '.leftNavCourseCatalogBtn',
    },
    {
        title: 'Scorecard & Rules',
        targetClass: '.leftScorecardRulesLogo',
    },
    {
        title: 'Compensation View',
        targetClass: '.leftNavCompViewLogo',
    },
    {
        title: 'Corrective Actions',
        targetClass: '.leftCorrectiveActionsLogo',
    },

    {
        title: 'Admin',
        targetClass: '.leftAdminWorkstreamLogo',
    },
    {
        title: 'Coaching',
        targetClass: '.leftCoachingLogo',
    },
    {
        title: 'Call Insight',
        targetClass: '.leftCallInsightLogo',
    },
    {
        title: 'GamePlan',
        targetClass: '.leftGamePlanLogo',
    },
];

export const kanbanColorMap = new Map<string, string>([
    ['In Progress', '#3299FF'],
    ['To Do', '#FDD444'],
    ['Needs Help', '#E23636'],
    ['Done', '#82DD55'],
]);

export const CREATE_COACHING_STRENGTH = 'coaching/create_coaching_strength';
export const UPDATE_COACHING_STRENGTH = 'coaching/update_coaching_strength';
export const REPLY_COACHING_STRENGTH = 'coaching/reply_coaching_strength';
export const GET_COACHING_STRENGTH_MODAL = 'coaching/coaching_strength';
export const COACHING_GOAL = 'coaching/coaching_goal';
export const COACHING_GOAL_SETTING = 'coaching/coaching_goal_setting';
export const COACHING_GOAL_REVIEW = 'coaching/coaching_goal_review';
export const COACHING_USER_SEARCH = 'coaching/user_search';
export const GET_COACHING_MONTHLY_METRICS = 'coaching/coaching_monthly_metrics';
export const GET_COACHING_METRIC_GOAL = 'coaching/coaching_metric_goal';
export const GET_COACHING_SCORECARD = 'coaching/coaching_scorecard';
export const INSERT_COACHING_SCORECARD = 'coaching/create_coaching_scorecard';
export const INSERT_COACHING_METRICS = 'coaching/create_coaching_metrics';
export const UPDATE_COACHING_METRICS = 'coaching/update_coaching_metrics';
export const GET_COACHING_EMP_SCORECARDS = 'coaching/coaching_emp_scorecards';
export const COACHING_DIRECT_REPORTEES = 'coaching/direct_reportees';
export const COACHING_CURRENT_MONTH_ACTIVITY = 'coaching/current_month_coaching_activity_summary';
export const COACHING_ACTIVITY_SUMMARY = 'coaching/coaching_activity_summary';
export const COACHING_ACTIVITY_EMPLOYEE_SEARCH = 'coaching/coaching_activity_employee_search';
export const COACHING_TODO_VIEW = 'coaching/coaching_todo_view';
export const COACHING_SHOUTOUT_CAROUSEL = 'coaching/coaching_shoutout_carousel';
export const COACHING_TODO_STATUS = 'coaching/coaching_todo_status';
export const COACHING_GOAL_INFO = 'coaching/coaching_goal_info';
export const DELETE_COACHING_SHOUTOUT = 'coaching/delete_coaching_shoutout';
export const CREATE_COACHING_GOAL = 'coaching/create_coaching_goal';
export const UPDATE_COACHING_GOAL_PARENT = 'coaching/update_coaching_goal_parent';
export const CONVERSATION_ACK_REQ_CHECK = 'coaching/conversation_acknowledge_request_check';
export const SIGNED_URL = 'coaching/signed_url';
export const COACHING_TEAM_MEMBERS_DATA = 'coaching/team_members_data';
export const COACHING_SHOUTOUT_VIEW = 'coaching/coaching_shoutout_view';
export const CREATE_COACHING_SHOUTOUT_COMMENT = 'coaching/create_shoutout_comment';
export const CREATE_COACHING_SHOUTOUT_COMMENT_REPLY = 'coaching/create_shoutout_comment_reply';
export const CREATE_COACHING_SHOUTOUT_REACTION = 'coaching/create_shoutout_reaction';
export const GET_ASSIGNED_COURSES = 'coaching/assigned_courses';
export const GET_ASSIGNED_PAST_COURSES = 'coaching/assigned_past_courses';
export const GET_BADGES = 'coaching/badges';
export const GET_SYSTEM_CONFIG = 'coaching/system_config';

// # Recalculation
export const GET_SCORECARD_WINDOWSTATUS = 'recalculation/scorecard_window_status';
export const CREATE_RECALCULATION_REQUEST = 'recalculation/create_recalculation_request';
export const GET_RECALCULATION_REQUEST = 'recalculation/recalculation_request';
export const GET_RECALCULATION_JOB_LOGS = 'recalculation/recalculation_job_logs';

//AskNow Ticket
export const URL_ASKNOW_CREATE_TICKET =
    'https://asknow.service-now.com/asknow?id=asknow_sc_cat_item&sys_id=4fbc01e51b67bf403c2e86e9cd4bcba6&sysparm_category=4cacba368747ed9497c8646d8bbb352c';
export const URL_ASKNOW_MY_RITMS = 'https://asknow.service-now.com/asknow?id=my_ritms';
export const URL_ASKNOW_MY_INCIDENTS = 'https://asknow.service-now.com/asknow?id=my_incidents';

//ConfigCode
export const COACHING_INSIGHTS_CONFIG = 'SHOW_COACHING_INSIGHT_MODULE_DIMENSION_ID';
export const MOOD_METER_CONFIG = 'HIDE_MOOD_METER_DIMENSION_ID';
export const USE_COACHING_SKILLS_CONFIG = 'USE_COACHING_SKILLS_DIMENSION_ID';
export const HIDE_GAMEPLAN_DIMENSION_ID = 'HIDE_GAMEPLAN_DIMENSION_ID';
export const USE_COACHING_MODEL_DIMENSION_ID = 'USE_COACHING_MODEL_DIMENSION_ID';

// Vertex AI
export const GET_VERTEX_AI_FEEDBACK = 'vertex_ai/ai_feedback';
export const GET_AI_GAMEPLAN_SUMMARY = 'vertex_ai/ai_gameplan_summary';

// Recording Upload (GCS signed-URL chunked upload — mirrors EmpowerWebRTC recording.js)
export const UPLOAD_GET_SIGNED_URLS = 'upload/get-signed-urls';
export const UPLOAD_MARK_COMPLETE = 'upload/mark-complete';

// Recording History
export const GET_RECORDING_HISTORY = 'recording/recording_history';
export const GET_RECORDING_STREAM = 'recording/recording_stream';
export const GET_EXTRACT_RECORDING_INSIGHTS = 'recording/extract_recording_insights';
export const GET_RECORDING_CAP = 'recording/recording_cap';

// Coaching Action Plan (FUEL Framework)
export const START_COACHING_ACTION_PLAN = 'coaching-action/start';
export const CREATE_ADDITIONAL_SESSION = 'coaching-action/session/additional';
export const GET_SESSION_BY_ID = 'coaching-action/session';
export const SAVE_FUEL_NOTES = 'coaching-action/session/fuel';
export const UPDATE_LAYOUT = 'coaching-action/session/layout';
export const ACKNOWLEDGE_ACTION_PLAN = 'coaching-action/acknowledgeActionPlan';
export const UPDATE_SESSION_OVERRIDE = 'coaching-action/session/override';

// Coaching Prepare Dashboard
export const GET_PREPARE_ASSOCIATES = 'coaching-action/prepare/associates';
export const GET_PREPARE_ASSOCIATE_METRICS = 'coaching-action/prepare/associate-metrics';
export const GET_CAP_DAILY_METRIC_SUMMARY = 'coaching-action/prepare/cap-daily-metric-summary';
export const GET_ROLLING_METRIC_SUMMARY = 'coaching-action/rolling-metric-summary';
export const GET_ASSOCIATE_ACTIVE_ACTION_PLANS = 'coaching-action/associate/active-action-plans';
export const GET_ASSOCIATE_HISTORICAL_ACTION_PLANS = 'coaching-action/associate/historical-action-plans';
export const GET_SCORECARD_VERSIONS_BY_SUPERVISOR = 'coaching-action/scorecard-versions';
export const GET_TEAMLEAD_COACHING_DASHBOARD_SEARCH = 'coaching-action/teamlead-coaching-dashboard-search';
export const GET_TEAMLEAD_COACHING_DASHBOARD_SKILLS_SEARCH = 'coaching-action/teamlead-coaching-dashboard-skills-search';
export const GET_MANAGER_COACHING_DASHBOARD_TEAMLEAD_BREAKDOWN_SEARCH = 'coaching-action/manager-coaching-dashboard-teamlead-breakdown-search';
export const GET_MANAGER_COACHING_DASHBOARD_SEARCH = 'coaching-action/manager-coaching-dashboard-search';
export const GET_MANAGER_COACHING_DASHBOARD_SKILLS_SEARCH = 'coaching-action/manager-coaching-dashboard-skills-search';
export const GET_MANAGER_COACHING_DASHBOARD_OBSERVATION_CAPABILITY_SEARCH = 'coaching-action/manager-coaching-dashboard-observation-capability-search';
